var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-content"},[_c('div',{ref:"alert"}),_c('BillboardForm',{attrs:{"mode":"create"},on:{"create":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }